import { Confirmer } from "@/components/confirmer";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Outlet } from "@tanstack/react-router";
import { useState } from "react";
import { ThemeProvider } from "../providers/ThemeProvider";
import { UpdateBanner } from "./UpdateBanner";

export function RootLayout() {
  const [bannerVisible, setBannerVisible] = useState(false);

  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="system"
      storageKey="ui-theme"
    >
      <TooltipProvider>
        <UpdateBanner onVisibilityChange={setBannerVisible} />
        <div className={`min-h-screen ${bannerVisible ? "pt-16" : ""}`}>
          <Outlet />
        </div>
        <Confirmer />
        <Toaster richColors />
      </TooltipProvider>
    </ThemeProvider>
  );
}
